import Accessibility from 'src/components/Accessibility/Accessibility';
import { connect } from 'react-redux';
import { FrameworkActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    theme: state.Framework.theme,
    specTheme: state.Specs.specs?.oemTheme,
    docSpecTheme: state.Specs.serviceDocsSpecs?.theme,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
});

const mapDispatchToProps = (dispatch: any) => ({
    updateTheme: (varTheme: string) => dispatch(FrameworkActionCreator.updateTheme(varTheme)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Accessibility);